/**
 * Analogous to CDS's RemoteImage component.
 *
 * We are going with this implementation to minimize the coupling
 * of the app-switcher to CDS versions.
 */

import { useCallback, useState } from 'react';
import { RemoteImage as CDSRemoteImage } from '@cbhq/cds-web/media';

import { useFallbackIllustrationUrl } from './hooks/useFallbackIllustration';

type RemoteImageProps = {
  source: string;
  testID?: string;
};

export const WIDTH = 40;
export const HEIGHT = 40;

export function RemoteImage({ source, testID }: RemoteImageProps) {
  const [finalSource, setFinalSource] = useState(source);
  const fallbackIllustration = useFallbackIllustrationUrl();

  const handleError = useCallback(() => {
    setFinalSource(fallbackIllustration);
  }, [fallbackIllustration]);
  if (source === '') {
    return null;
  }
  return (
    <CDSRemoteImage
      data-testid={testID}
      source={finalSource}
      onError={handleError}
      width={WIDTH}
      height={HEIGHT}
    />
  );
}
